import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  const localize = (msg) => {
    if (typeof msg !== "string") return msg;
    if (msg.toLowerCase().includes("email")) return "Geçerli bir e-posta adresi girin.";
    return msg;
  };
  if (typeof detail === "string") return localize(detail);
  if (Array.isArray(detail))
    return detail.map((e) => localize(e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return localize(detail.msg);
  return String(detail);
}
